import React from 'react';
import { Modal } from '@/pages/common';
import ImageCropper from '../ImageCropper';

const CropImageModal = ({
  isOpen,
  imageSrc,
  onCropComplete,
  onCancel,
  locale,
  isSaving = false,
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      maxWidth={544}
      maxHeight={707}
      onClose={onCancel}
      variant="regular"
      disablePadding
      disableOverFlow
      closeOnOutsideClick={false}
    >
      <ImageCropper
        imageSrc={imageSrc}
        onCropComplete={onCropComplete}
        onCancel={onCancel}
        locale={locale}
        isSaving={isSaving}
      />
    </Modal>
  );
};

export default CropImageModal;
